
import { convert } from './convert';
import moment from 'moment'

export function numberFloatOnly(value) {
  //eslint-disable-next-line
  const regxFormat = /^[]?\d*(?:[.]\d*)?$/;
  var result = regxFormat.test(value)
  return result;
}

export function numberOnly(value) {
  try {
    const regxFormat = /^[0-9]*$/;
    var result = regxFormat.test(value)
    return result;
  } catch (err) {
    console.log(err, "numberOnly")
    return false;
  }

}

export function isFirstLetterCaps(str) {
  try {
    var first = str.charAt(0).toUpperCase();
    var letter = str.slice(1)
    var fullname = first + letter
    return fullname
  } catch (err) {
    return "";
  }
}
export function formatNumber(num, defaultFixed) {

  try {
    if (defaultFixed && parseInt(defaultFixed) > 0) {
      defaultFixed = parseInt(defaultFixed);
    } else {
      defaultFixed = 5;
    }
    var numval = num.toString();
    numval = convert(numval);

    var chkDeci = numval.split(".");
    var returnNum = num;
    if (chkDeci.length == 2) {
      if (defaultFixed < chkDeci[1].length) {
        returnNum = toFixedWithoutRound(numval, defaultFixed);
      } else {
        var fix = chkDeci[1].length;
        returnNum = toFixedWithoutRound(numval, fix);
      }
    }

    return returnNum;
  } catch (err) {
    console.log(err, 'errerrerrerr')
    return 0;
  }

}


export function shortValue(value) {
  try {
    var Amount = value.toFixed(2);
    return Amount;
  } catch (err) {
    return "";
  }
}

export const truncateDecimals = (num, decimals) => {
  num = convert(num);
  let s = num.toString(),
    p = s.indexOf(".");
  s += (p < 0 ? ((p = 1 + s.length), ".") : "") + "0".repeat(decimals);
  return s.slice(0, p + 1 + decimals);
};

export function toFixedWithoutRound(number, decimalPlaces = 2) {
  try {
    let numberString = number.toString();
    let decimalIndex = numberString.indexOf('.');
    if (decimalIndex === -1) {
      return number;
    }
    numberString = numberString.slice(0, decimalIndex + decimalPlaces + 1);
    let truncatedNumber = parseFloat(numberString);
    return truncatedNumber;
  } catch (err) {
    return 0;
  }

}
export function formatAddress(address) {
  try {
    var addr = address.substring(0, 16);
    var addr1 = address.substring(30, 42);
    var concat = addr + "...." + addr1;
    return concat;
  } catch (err) {
    return "";
  }
}

export function shortText(address) {
  try {
    var addr = address.substring(0, 4);
    var addr1 = address.substring(36, 42);
    var concat = addr + "...." + addr1;
    return concat;
  } catch (err) {
    return "";
  }
}

export function calculateRoundNumber(startDateISO, splitType) {
  console.log(splitType, startDateISO, 'splitType')
  if (!startDateISO || !splitType)
    return {
      roundNumber: 0,
      currentRoundStartDate: new Date(),
      currentRoundEndDate: new Date(),
      remainingDays: 0,
      percentageRemaining: 0,
      status: false,
    };

  const currentDateUTC = new Date(
    Date.UTC(
      new Date().getUTCFullYear(),
      new Date().getUTCMonth(),
      new Date().getUTCDate(),
      new Date().getUTCHours(),
      new Date().getUTCMinutes(),
      new Date().getUTCSeconds()
    )
  );
  let roundNumber = 0;
  let currentRoundStartDate = new Date(startDateISO);
  let currentRoundEndDate;
  let remainingDays = 20;
  let percentageRemaining = 20;
  console.log(currentRoundStartDate, 'currentRoundStartDate')
  while (currentRoundStartDate <= currentDateUTC) {
    switch (splitType) {
      case "day":
        currentRoundStartDate = new Date(
          Date.UTC(
            currentDateUTC.getUTCFullYear(),
            currentDateUTC.getUTCMonth(),
            currentDateUTC.getUTCDate(),
            0,
            0,
            0
          )
        );
        currentRoundEndDate = new Date(currentRoundStartDate);
        currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() + 1);
        remainingDays = Math.ceil(
          (currentRoundEndDate - currentDateUTC) / (1000 * 60 * 60)
        );
        percentageRemaining = (remainingDays / 24) * 100; // percentage of remaining hours in a day
        percentageRemaining = Math.round(100 - percentageRemaining);
        remainingDays = 1;
        break;
      case "week":
        currentRoundEndDate = new Date(currentRoundStartDate);
        currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() + 6);
        break;
      case "month":
        currentRoundEndDate = new Date(currentRoundStartDate);
        currentRoundEndDate.setUTCMonth(
          currentRoundEndDate.getUTCMonth() + 1
        );
        currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
        console.log(currentRoundStartDate, currentRoundEndDate, 'monnth')
        break;
      case "Quarterly":
        currentRoundEndDate = new Date(currentRoundStartDate);
        currentRoundEndDate.setUTCMonth(
          currentRoundEndDate.getUTCMonth() + 3
        );
        currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
        break;
      case "half":
        currentRoundEndDate = new Date(currentRoundStartDate);
        currentRoundEndDate.setUTCMonth(
          currentRoundEndDate.getUTCMonth() + 6
        );
        currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
        break;
      case "full":
        currentRoundEndDate = new Date(currentRoundStartDate);
        currentRoundEndDate.setUTCFullYear(
          currentRoundEndDate.getUTCFullYear() + 1
        );
        currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
        break;
      default:
        console.error(
          'Invalid split type. Use "day", "week", "month", "half", or "full".'
        );
    }

    roundNumber++;
    if (
      currentDateUTC >= currentRoundStartDate &&
      currentDateUTC <= currentRoundEndDate
    ) {
      if (splitType !== "day") {
        remainingDays = Math.ceil(
          (currentRoundEndDate - currentDateUTC) / (1000 * 60 * 60 * 24)
        );
        const totalDays =
          Math.ceil(
            (currentRoundEndDate - currentRoundStartDate) /
            (1000 * 60 * 60 * 24)
          ) + 1;
        console.log(totalDays, 'totalDays')
        percentageRemaining = (remainingDays / totalDays) * 100;
        percentageRemaining = Math.round(100 - percentageRemaining);
      }
      break;
    } else {
      currentRoundStartDate = new Date(currentRoundEndDate);
      currentRoundStartDate.setUTCDate(currentRoundStartDate.getUTCDate() + 1);
    }
  }
  return {
    roundNumber: roundNumber,
    currentRoundStartDate: currentRoundStartDate.toISOString(),
    currentRoundEndDate: currentRoundEndDate.toISOString(),
    remainingDays: remainingDays,
    percentageRemaining: percentageRemaining,
    status: true,
  };
}


export async function getFormatMulticall(results, name, pos) {

  try {
    var returnVal = (results && results.results && results.results[name]
      && results.results[name].callsReturnContext &&
      results.results[name].callsReturnContext &&
      results.results[name].callsReturnContext[pos] &&
      results.results[name].callsReturnContext[pos].returnValues &&
      results.results[name].callsReturnContext[pos].returnValues[0]) ?
      results.results[name].callsReturnContext[pos].returnValues[0] : "";
    return returnVal;
  } catch (err) {
    return "";
  }
}

export async function getFormatMulticall1(results, name, pos) {

  try {
    var returnVal = (results && results.results && results.results[name]
      && results.results[name].callsReturnContext &&
      results.results[name].callsReturnContext &&
      results.results[name].callsReturnContext[pos] &&
      results.results[name].callsReturnContext[pos].returnValues &&
      results.results[name].callsReturnContext[pos].returnValues) ?
      results.results[name].callsReturnContext[pos].returnValues : "";
    return returnVal;
  } catch (err) {
    return "";
  }
}

export function tokenValue(rate, amt, perBnb, isBuy) {
  var swapToken = 0;
  if (isBuy == "USDT") {
    var perToken = rate * amt;
    swapToken = perToken / 1000000;
  } else if (isBuy == "BNB") {
    perBnb = perBnb / 100000000;
    var _amount = perBnb * amt;
    var perToken = rate * _amount;
    swapToken = perToken / 1000000;
  }

  return swapToken ? {
    swapToken: formatNumber(swapToken, 6)
  } : { swapToken: "" }
}